import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=d4fc7ff8&scoped=true"
import script from "./feedback.vue?vue&type=script&lang=ts"
export * from "./feedback.vue?vue&type=script&lang=ts"
import style0 from "./feedback.vue?vue&type=style&index=0&id=d4fc7ff8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4fc7ff8",
  null
  
)

export default component.exports